<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">DEDICATION</a></p>
<p><span href="#/c004" title="Link target outside of Sample">H</span></p>
<p><span href="#/c005" title="Link target outside of Sample">H</span></p>
<p><span href="#/c006" title="Link target outside of Sample">H</span></p>
<p><span href="#/c007" title="Link target outside of Sample">From Bestselling Author | Kailin Gow | the phantom diaries</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Now Available from | Bestselling Author Kailin Gow | dark memories (the phantom diaries, #2)</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Now Available from | Bestselling Author Kailin Gow | Wicked Woods</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Want to Know More about the PULSE Series, Author Insight, Author Appearance, Contests and Giveaways? | Join the PULSE Series Official Facebook Fan Page at:</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Talk to Kailin Gow at:</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Want More Edgy books like PULSE?</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Sparklesoup.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?34e2de27